import login from './login/login_es'
import forgotPassword from './forgotPassword/forgotPassword_es'
import changePassword from './changePassword/changePassword_es'
import updatePassword from './updatePassword/updatePassword_es'
import home from './home/home_es'
import errorsAndNotifications from './errorsAndNotifications/errorsAndNotifications_es';
import ripsDetail from './rips/ripsDetail_es'
import dashboard from './dashboard/dashboard_es'

const spanishMessages = {
  globalErrorUnknown: '¡Tuvimos un problema técnico! Por favor, intente de nuevo o contacte a su equipo de soporte técnico.',
  loading: 'Cargando',
  errorTitle: 'Ha ocurrido un error',
  defaultErrorDescription: 'Por favor contacte al equipo de soporte técnico para mayor información.',
  badCredentials: '¡Credenciales incorrectas! Por favor, intente de nuevo.',
  buttons: {
    close: 'Cerrar',
    save: 'Guardar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    accept: 'Aceptar',
    add: 'Agregar',
    search: 'Buscar',
  },
  errors: {
    inputValidations: {
      required: 'Requerido',
      invalidFormat: 'El formato es incorrecto',
      maxLength: 'Se ha excedido el límite de {n} caracteres',
      minLength: 'Mínimo {n} caracteres'
    },
    authorizationRequest: {
      emptyAuthorization: "La creación de la autorización falló, comuníquese con el equipo de soporte para obtener más información."
    },
    dispensingRequest: {
      emptyApprovedProducts: "No se aprobó ningún producto para esta autorización, comuníquese con el equipo de soporte para obtener más información."
    },
    voidAuthorizations: {
      success: 'Se anuló correctamente la autorización.'
    }
  },
  drawer: {
    logout: 'Cerrar sesión'
  },
  footer: {
    privacyLabel: 'Privacidad'
  },
  locales: {
    'es-DO': 'Español',
    es: 'Español',
    en: 'Inglés'
  },
  identityDocumentTypes: {
      passport: 'Pasaporte',
      nationalIdentityCard: 'Número de identificación nacional',
      socialSecurityNumber: 'Número de seguro social',
      taxIdentificationNumber: 'Número de identificación tributaria',
      electoralRegistryNumber: 'Número de identificación electoral'
  },
  genders: {
    male: 'Hombre',
    female: 'Mujer'
  },
  posology: {
      day: ' día | días',
      unit: 'unidad | unidades',
      medicalDeviceDescription: 'Usar {0} ({1}) {2} por {3} ({4}) {5}',
      half: 'medio/a',
      quarter: ' un cuarto | {value} cuartos',
      andConnector: 'y',
      pointConnector: 'punto',
  },
  sponsors: {
    umbrella: "Umbrella Osigu ARS",
    humano: 'Humano Seguros',
    universal: 'ARS Universal',
    primera: 'ARS Primera',
    humanoCategories: {
        global: "Global",
        platinum: "Platinum",
        conventional: "Convencional"
    }
  },
  voidAuthorization: {
    back: "Regresar",
    confirm: "Sí, anular",
    title: "Anular autorización",
    titleOnlyClaim: "Anular reclamo",
    hint: "Confirme para anular esta autorización. Esta acción no puede ser revertida.",
    hintOnlyClaim: "Confirme para anular este reclamo. Esta acción no puede ser revertida."
  },
  actions: {
    upload: 'Cargar',
    delete: 'Eliminar',
    replace: 'Reemplazar',
    view: 'Visualizar',
    attention: 'Atención',
    download: 'Descargar',
    edit: 'Editar'
  },
  yes: 'Si',
  no: 'No',
  supportFileUploadSuccess: 'El archivo se cargó correctamente',
  supportFileDeleteSuccess: 'El archivo se eliminó correctamente',
  supportFileRestrictedAsAccountLevel: 'Requerido a nivel cuenta',
  emptyResults: "No se encontraron resultados",
  cancelFormButton: "Cancelar",
  chronicTreatmentLabel: 'Tratamiento crónico',
  errorLoadingFile: 'Ha ocurrido un error al cargar el archivo, por favor intente de nuevo o contacte al equipo de soporte técnico.',
  informationSuccessfullyUpdated: 'Información actualizada correctamente',
  invalidFileType: 'Tipo de archivo inválido, tipos de archivo permitidos: PNG, JPEG, XML, PDF',
  login,
  forgotPassword,
  changePassword,
  updatePassword,
  home,
  errorsAndNotifications,
  ripsDetail,
  dashboard
}

export default spanishMessages